import { createFileRoute, Outlet } from '@tanstack/react-router'
import z from 'zod'
import { CanteenListWidget } from '@/widgets/canteen-list-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.searchByName': z.string().optional(),
  'filter.names': z.array(z.string()).optional(),
  'filter.active': z.boolean().optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/administration/reference-books/canteens/list')({
  staticData: {
    meta: {
      title: 'Столовые',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <CanteenListWidget />
      <Outlet />
    </>
  )
}
